import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M6.996 20.454 9 15H2.498c-1-3.49-.492-7.693 1.498-11h11.001L15 15l-6.002 6.95c-.988.246-2-.444-2-1.496ZM16.997 14.97h5.001V3h-5v11.97Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }